import React from "react";
import styles from "./style.module.css";

const InboxTabs = ({ tabs, selectedTab, onSelectTab, counts, frontIcon }) => {
  return (
    <div className={styles.tabStrip}>
      {tabs.map((tab) => {
        const isActive = tab === selectedTab;
        const count = counts[tab];
        return (
          <button
            key={tab}
            className={styles.tab}
            onClick={() => onSelectTab(tab)}
            data-isActive={isActive}
          >
            {frontIcon && frontIcon.tab === tab && frontIcon.icon}
            <span className={styles.tabLabel}>{tab}</span>
            {count > 0 && (
              <span className={`${styles.tabBadge} ${isActive ? styles.tabBadgeActive : ""}`}>
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default InboxTabs;
